import { BaseModel } from './base-model';

export class Lgpd extends BaseModel {

	public id: string;
	public name: string;

	constructor() {
		super();
		this.id = null;
        this.name = null;
	}

}

export interface AttachmentInfo {
	body: AttachmentInfo;
	attachmentId: string;
	description: string;
	file?: File;
}

interface File extends Blob {
    readonly lastModified: number;
    readonly name: string;
    readonly webkitRelativePath: string;
}
